import React from 'react'; 

const OnboardingView = ({ onComplete }) => {
    const [currentStep, setCurrentStep] = React.useState(0);

    const steps = [
        {
            title: "Welcome to AUTSAI",
            description: "Find a hiking buddy anytime you want",
            icon: "welcome.png",
            detail: "We will match you with compatible partners for your next adventure"
        },
        {
            title: "Browse Trails",
            description: "Explore Top Trails",
            icon: "browse.png",
            detail: "Choose the hiking trail that fits your level and type of adventure"
        },
        {
            title: "Match with Buddies",
            description: "Match with compatible Buddies",
            icon: "matchbuddies.png",
            detail: "Our matching system pairs you with hikers who share your adventure level and trail goals."
        },
        {
            title: "Schedule & Meet",
            description: "Schedule and Meet",
            icon: "scheduleandmeet.png",
            detail: "Check your agenda, and get ready to meet your new hiking buddy at the starting point for an adventure to remember!"
        }
    ];

    const handleNext = () => {
        if (currentStep < steps.length - 1) {
            setCurrentStep(currentStep + 1);
        } else if (currentStep === steps.length - 1) {
            onComplete(); // Call once and only at the end
        }
    };
    

    return (
        <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center">
            <div className="relative w-96 h-160 flex flex-col justify-center items-start bg-white rounded-2xl shadow-xl p-12">
            {steps[currentStep] && (
  <img src={steps[currentStep].icon} alt="Step icon" className="w-30 h-30 mb-8 self-center" />
)}

                <h1 className="text-xl font-bold mb-4 text-left">{steps[currentStep].title}</h1>
                <p className="text-gray-600 text-sm mb-5 text-left">{steps[currentStep].description}</p>
                <p className="text-gray-500 text-lg text-left max-w-xs">{steps[currentStep].detail}</p>
            </div>

            {/* Progress dots */}
            <div className="flex space-x-2 mt-6">
                {steps.map((_, index) => (
                    <div
                        key={index}
                        className={`w-2 h-2 rounded-full ${index === currentStep ? 'bg-purple-600' : 'bg-gray-300'}`}
                    />
                ))}
            </div>

            {/* Minimalist Next Button */}
            <button
                onClick={handleNext}
                className="absolute bottom-14 right-16 text-gray-500 text-lg font-semibold"
            >
                Next
            </button>
        </div>
    );
};

export default OnboardingView;
